import PropTypes from 'prop-types'
import { assetsTypesShortList } from 'app/core/constants/assetsTypes'

export const assetTypesList = PropTypes.arrayOf(PropTypes.oneOf(assetsTypesShortList))
export const assetType = PropTypes.oneOf(assetsTypesShortList)
